import Vue from "vue";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import ResponsiveHelper from "@Scripts/Infrastructure/ResponsiveHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Chatbot", "Catalogue", "Contact", "CookieToast", "CatalogueSearch", "Certification", "WhereToBuy", "Newsletter", "Account", "BremboExpert", "Genuine", "Support", "TechInfo"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created: function () {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        ResponsiveHelper.onResize();

        document.querySelectorAll(".section-wrap").forEach(x => {
            x.classList.remove("hden");
        })

        this.setStikyHeader();
        this.setOpenLang();
        this.setOpenShare();
        this.setQrStoreChina();
        this.setAnalytics();
        this.openCookieToastDialog();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setStikyHeader() {
        let header = document.getElementById("Header"),
            search = document.getElementById("Search"),
            showSearch = document.getElementById("ShowSearch")

        if (header) {
            window.addEventListener("scroll", function () {
                if (window.scrollY > 75) {
                    header.setAttribute("data-sticky", "");
                    search.setAttribute("data-sticky", "");
                } else {
                    header.removeAttribute("data-sticky");
                    search.removeAttribute("data-sticky");
                    search.removeAttribute("data-show");
                    showSearch.removeAttribute("data-active");
                }
            });
        }

        document.querySelectorAll(".show-search-button").forEach(element => {
            element.addEventListener("click", event => {
                search.toggleAttribute("data-show");
                element.toggleAttribute("data-active");
            });
        });
    }

    private static setOpenShare() {
        let shareButton = document.querySelectorAll(".share .open-share");
        for (const item of shareButton) {
            if (item) {
                item.addEventListener("click", () => {
                    let share = document.querySelectorAll(".share");
                    for (const cta of share) {
                        if (cta) {
                            cta.classList.toggle("show");
                        }
                    }
                });
            }
        }

        document.addEventListener("click", event => {
            let el = <HTMLElement>event.target;
            if (shareButton[0] && !shareButton[0].contains(el)) {
                let parentElement = document.getElementsByClassName("share");
                for (const cta of parentElement) {
                    cta.classList.remove("show");
                }
            }
        });
    }

    private static setQrStoreChina() {
        let shareButton = document.querySelectorAll(".button-store-zh, .modal-store-zh .close");
        for (const item of shareButton) {
            if (item) {
                item.addEventListener("click", () => {
                    let share = document.querySelectorAll(".modal-store-zh");
                    for (const cta of share) {
                        if (cta) {
                            cta.classList.toggle("show");
                        }
                    }
                });
            }
        }
    }

    private static setAnalytics() {
        let dataGaeventLinkTrue = document.querySelectorAll(".ga-event");
        for (const item of dataGaeventLinkTrue) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendEvent(
                        this.getAttribute("data-ganame") ? this.getAttribute("data-ganame") : "click",
                        this.getAttribute("data-gacategory"),
                        this.getAttribute("data-galabel") === "link" ? this.getAttribute("href") : this.getAttribute("data-galabel"),
                    );
                });
            }
        }

        // ZH ADS
        let zhBuyNowDetail = document.querySelectorAll(".ga-event-zh[data-gacategory=\"buynow\"]");
        for (const item of zhBuyNowDetail) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendCustomEvent("click", { buynow_zh: this.getAttribute("href") });
                }, false);
            }
        }
    }

    private static setOpenLang() {
        let expLang = document.querySelector(".exp-lang");
        if (expLang) {
            expLang.addEventListener("click", e => {
                document.querySelector(".box-select-language").classList.add("show");
            }, false);
        }

        let closeExpLang = document.querySelectorAll(".backdrop, .close, .wrap-tap, .wrap-back");
        for (const item of closeExpLang) {
            if (item) {
                item?.addEventListener("click", e => {
                    document.querySelector(".box-select-language")?.classList.remove("show");
                }, false);
            }
        }
    }

    private static openCookieToastDialog() {
        let ctas = document.querySelectorAll("[data-cookietoast]");
        for (const item of ctas) {
            item.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("cookieToastStore/setCookieToastVisible", true);
            })
        }
    }
}